
import store from '@/store';
import { getUrlVars } from '@/lib/utils';
import {
  ref, computed, Ref,
} from '@vue/composition-api';

import Alert from '@/components/Alert.vue';
import Controls from '@/components/Controls.vue';
import MultiLink from '@/components/MultiLink.vue';
import ProvVis from '@/components/ProvVis.vue';
import TimeLine from '@/components/TimeLine.vue';

export default {
  name: 'App',

  components: {
    Alert,
    Controls,
    MultiLink,
    ProvVis,
    TimeLine,
  },

  setup() {
    const network = computed(() => store.state.network);
    const selectedNodes = computed(() => store.state.selectedNodes);
    const loadError = computed(() => store.state.loadError);
    const slicedNetwork = computed(() => store.state.slicedNetwork.length > 1);

    const multilinkContainer: Ref<Element | null> = ref(null);
    const multilinkContainerDimensions = computed(() => {
      if (multilinkContainer.value !== null) {
        return {
          width: multilinkContainer.value.clientWidth - 24,
          height: multilinkContainer.value.clientHeight - 24,
        };
      }
      return null;
    });

    const urlVars = getUrlVars(); // Takes workspacce and network

    store.dispatch.fetchNetwork({
      workspaceName: urlVars.workspace,
      networkName: urlVars.network,
    }).then(() => {
      store.dispatch.createProvenance();
      store.dispatch.guessLabel();
    });

    // Provenance vis boolean
    const showProvenanceVis = computed(() => store.state.showProvenanceVis);

    return {
      network,
      selectedNodes,
      loadError,
      multilinkContainer,
      multilinkContainerDimensions,
      showProvenanceVis,
      slicedNetwork,
    };
  },
};
